module.exports = __webpack_public_path__ + "static/media/2020-05-18 internbit-resources.da8d1616.md";